<template>
	<PageTemplate>
		<template #header>
			<div class="py-4 serif">
				<h1>shadowlerone</h1>
			</div>
		</template>
		<div class="description transition-fade serif">
	
			<!-- <h1>shadowlerone</h1> -->
			<figure
				class="col-6 col-md-3 float-start mb3 me-3 rounded swipe wiggle pfp"
			>
				<img
					class="img-fluid rounded swipe"
					src="/assets/20240416-_Z9A7370.jpg"
				/>
				<!-- <figcaption class=""><a href="https://www.instagram.com/photos.bouvier/">Photo by Charles Antoines</a></figcaption> -->
			</figure>
			<p class="swipe">Hey there!</p>
			<p>
				I'm currently pursuing a Masters in Urban Studies. I have a
				fascination with the built environment and how it shapes how
				people grow and think. I'm also interested in how technology
				affects our lives, how it shapes our ideas, and how it may
				sublty or not so subtly perpetuate social injustices.
			</p>
			<p>
				I'm also very interested in Game Design. I've done a few game
				jams, where I've worked on sound, music, and programming. I'm
				particularly interested in using music and sound to enhance
				storytelling.
			</p>
		</div>
	</PageTemplate>
</template>
<script setup>
import PageTemplate from "./PageTemplate.vue";
</script>
